import React from 'react';
import { connect } from 'react-redux';
import { showLoading, hideLoading } from '../../Redux/Action';
import Autocomplete from '../../Utilities/Autocomplete';
import PersonService from '../../Service/PersonService';
import Swal from 'sweetalert2';
import OrganizationService from '../../Service/OrganizationService';
import PersonManageTable from './PersonManage_component/PersonManage_table';
import PersonManageModal from './PersonManage_component/PersonManage_modal';
import queryString from 'query-string';

class PersonManage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            currentPersonID: null,
            dataCount: 0,
            data: [],
            searchPersonName: '',
            searchedOrganizationText: '',
            searchOrganization: {},
            searched: {
                isSearched: false,
                searchedPersonName: '',
                searchedOrganization: {}
            },
            currentPage: 1,
            limit: 5
        }
    }

    componentDidMount() {
        this.searchPerson(null, null, null);

        if (this.props.location) {
            var search = queryString.parse(this.props.location.search);
            if (search && search.create === 'true') {
                this.setState({ show: true });
            }
        }
    }

    onChangeSearch = (name, value) => {
        this.setState({ [name]: value });
    }

    searchOrganization = (Name) => {
        return OrganizationService.searchOrganization(Name);
    }

    searchPerson = (Name, OrganizationID) => {
        this.props.dispatch(showLoading());
        var personService = PersonService.searchPerson(Name, OrganizationID);
        personService
            .then(result => {
                this.props.dispatch(hideLoading());
                if (result.errors) {
                    Swal.fire({
                        title: 'เกิดข้อผิดพลาด',
                        text: result.errors[0].Message,
                        type: 'error'
                    });
                    return;
                }
                console.log(result);
                this.setState({
                    data: result.data.SearchPerson,
                    dataCount: result.data.SearchPerson.length
                })
            })
            .catch(err => {
                this.props.dispatch(hideLoading());
                console.log(err);
                Swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: 'เกิดข้อผิดพลาดระหว่างการเรียกข้อมูล',
                    type: 'error'
                });
            })
    }

    searchPersonAfterSetState = () => {
        if (this.state.searched.isSearched === true) {
            this.searchPerson(
                this.state.searched.searchedPersonName,
                this.state.searched.searchedOrganization.OrganizationID
            )
        }
        else {
            this.searchPerson(
                null,
                null
            )
        }
    }

    getPersonDataTable = (Offset, Limit) => {
        var newData = [];
        var data = [...this.state.data];
        if (data.length === 0) return [];
        for (var i = Offset; i < (Offset + Limit); i++) {
            if (data[i] === undefined)
                break;
            newData.push(data[i]);
        }
        console.log(newData)
        return newData;
    }

    getPersonDetail = (id) => {
        for (var i of this.state.data) {
            if (i.PersonID === id)
                return i;
        }
    }

    onChangeTableState = (name, value, value2) => {
        if (name === '')
            this.setState({
                currentPage: value,
                limit: value2
            }, () => {
                this.getPersonDataTable((this.state.currentPage - 1) * this.state.limit, this.state.limit);
            });
        else
            this.setState({ [name]: value }, () => {
                this.getPersonDataTable((this.state.currentPage - 1) * this.state.limit, this.state.limit);
            });
    }

    changeCurrentPersonID = (id) => {
        this.setState({
            currentPersonID: id,
            show: true
        })
    }

    hideModal = (callback) => {
        (this.state.show === false) ?
            this.setState({
                show: true
            })
            : this.setState({
                show: false,
                currentPersonID: null
            }, () => {
                if (typeof callback === 'function')
                    callback()
            });
    }

    createPerson = (PersonName, OrganizationID, Phone, Remark) => {
        return PersonService.createPerson(PersonName, OrganizationID, Phone, Remark)
            .then(res => {
                this.searchPersonAfterSetState();
                return res;
            })
            .catch(err => {
                this.props.dispatch(hideLoading());
                return Promise.reject(err);
            });
    }

    updatePerson = (PersonID, PersonName, OrganizationID, Phone, Remark) => {
        return PersonService.updatePerson(PersonID, PersonName, OrganizationID, Phone, Remark)
            .then(res => {
                this.searchPersonAfterSetState();
                return res;
            })
            .catch(err => {
                this.props.dispatch(hideLoading());
                return Promise.reject(err);
            });
    }

    deletePerson = (PersonID) => {
        Swal.fire({
            title: 'ลบบุคคล',
            text: 'ต้องการลบบุคคลนี้หรือไม่ ?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก',
            reverseButtons: true
        })
            .then(res => {
                if (res.value)
                    PersonService.deletePerson(PersonID)
                        .then(result => {
                            if (result.errors) {
                                Swal.fire({
                                    title: 'เกิดข้อผิดพลาด',
                                    text: result.errors[0].Message,
                                    type: 'error'
                                })
                                return;
                            }
                            Swal.fire({
                                title: 'ลบข้อมูลสำเร็จ',
                                type: 'success'
                            })
                            this.searchPersonAfterSetState();
                        })
                        .catch(err => {
                            console.log(err);
                            Swal.fire({
                                title: 'เกิดข้อผิดพลาด',
                                text: 'เกิดข้อผิดพลาดระหว่างการเรียกข้อมูล',
                                type: 'error'
                            });
                        });
            });
    }

    clickSearch = () => {
        if (
            this.state.searchPersonName === '' &&
            this.state.searchOrganization.OrganizationID === undefined
        ) {
            this.clearSearch();
            return;
        }
        this.setState({
            //searchPersonName: '',
            //searchOrganization: {},
            currentPage: 1,
            searched: {
                isSearched: true,
                searchedPersonName: this.state.searchPersonName,
                searchedOrganization: this.state.searchOrganization,
            }
        }, () => {
            this.searchPersonAfterSetState();
        });
    }

    clearSearch = () => {
        this.setState({
            searchPersonName: '',
            searchOrganization: {},
            currentPage: 1,
            searched: {
                isSearched: false,
                searchedPersonName: '',
                searchedOrganization: {}
            }
        }, () => {
            this.searchPerson(
                null,
                null
            )
        })
    }

    render() {
        return (
            <>
                <div className='custom-block mb-4'>
                    <div className='row align-items-end'>
                        <div className='form-group col-12 col-lg-6'>
                            <label className='form-label'>ชื่อบุคคล</label>
                            <input
                                placeholder='ชื่อบุคคล'
                                className='form-control'
                                value={this.state.searchPersonName}
                                name='searchPersonName'
                                onChange={e => this.onChangeSearch(e.target.name, e.target.value)}
                            />
                        </div>
                        <div className='form-group col-12 col-lg-6'>
                            <label className='form-label'>หน่วยงาน</label>
                            <Autocomplete
                                getData={this.searchOrganization}
                                name='searchOrganization'
                                labelName='หน่วยงาน'
                                dataName='Organization'
                                onChangeSelect={this.onChangeSearch}
                                selectValue={this.state.searchOrganization}
                                searchOnChange
                            />
                        </div>
                    </div>
                    <div className='d-flex justify-content-end'>
                        <button type='button' className='mr-2 btn btn-outline-danger' onClick={this.clearSearch}>ยกเลิก</button>
                        <button type='button' className='btn btn-outline-primary' onClick={this.clickSearch}>ค้นหา</button>
                    </div>
                </div>
                <div className='custom-block'>
                    <PersonManageTable
                        data={this.getPersonDataTable((this.state.currentPage - 1) * this.state.limit, this.state.limit)}
                        dataCount={this.state.dataCount}
                        onChangeTableState={this.onChangeTableState}
                        searched={this.state.searched}
                        currentPage={this.state.currentPage}
                        limit={this.state.limit}
                        changeCurrentPersonID={this.changeCurrentPersonID}
                        clickAddPerson={this.hideModal}
                        clickDeletePerson={this.deletePerson}
                    />
                </div>
                <PersonManageModal
                    show={this.state.show}
                    hide={this.hideModal}
                    getPersonDetail={this.getPersonDetail}
                    currentPersonID={this.state.currentPersonID}
                    searchOrganization={this.searchOrganization}
                    createPerson={this.createPerson}
                    updatePerson={this.updatePerson}
                />
            </>
        );
    }
}

export default connect(null)(PersonManage);